import { Link } from 'react-router-dom';
import { navCategories } from '@/mocks/navigationData';

export default function Footer() {
  const popularCategories = navCategories.slice(0, 4);

  const quickLinks = [
    { label: '关于蓝导航', to: '/about' },
    { label: '提交网站', to: '/about' },
    { label: '联系我们', to: '/about' },
    { label: '使用帮助', to: '/about' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg transition-transform duration-300 group-hover:scale-110">
                <i className="ri-compass-3-fill text-xl text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-950">
                蓝导航
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              精选网址导航，一站直达精彩。汇聚海量优质网站资源，分类清晰、访问便捷，帮您快速定位所需网站。
            </p>
            <div className="flex items-center gap-3">
              <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="mailto:contact@lan-dao.com" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors duration-200" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {popularCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-base text-foreground-500"></i>
                contact@lan-dao.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-base text-foreground-500"></i>
                400-888-0000
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-base text-foreground-500"></i>
                北京市海淀区中关村
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2023 - {new Date().getFullYear()} 蓝导航 Lan-Dao.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">使用条款</a>
            <a href="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}